import React from 'react';
import { ProviderProps } from '@app/shell/types';

const I18nProvider = ({ children }: ProviderProps) => <>{children}</>;

export default I18nProvider;
